import React, {useEffect} from "react";

import {
  DefaultButton,
  Dialog,
  DialogFooter,
  DialogType,
  PrimaryButton,
} from "@fluentui/react";

const CreateEditCreditReportActiveUserThresholdingModal = ({
  showModal,
  toggleShowModal,
  submitForm
}) => {


    return (
    <Dialog
      hidden={!showModal}
      onDismiss={toggleShowModal}
      modalProps={{
        isBlocking: true,
      }}
      dialogContentProps={{
        type: DialogType.normal,
        title: "Warning",
        subText: "Submitting will update cobrands, cobrand tags, and clients for the selected threshold. This includes removing any cobrands, cobrand tags, or clients that were removed from the UI. Do you wish to continue?`",
      }}
    >
      <DialogFooter>
        <PrimaryButton
          onClick={() => {toggleShowModal(); submitForm(); }}
          text="Update Threshold"
        />
        <DefaultButton
          onClick={toggleShowModal}
          text="Cancel"
        />
      </DialogFooter>
    </Dialog>
  );
};

export default CreateEditCreditReportActiveUserThresholdingModal;
